import { Page } from "@/components/page-base";
import GroupsIcon from "@mui/icons-material/Groups";
import {
  Card,
  CardsContainer,
  SearchContainer,
  SaleContainer,
  DgContainer
} from "./styles";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import PixOutlinedIcon from "@mui/icons-material/PixOutlined";
import theme from "@/styles/theme";
import { DatagridResponsive } from "@/components/datagrid-base";
import { useEffect, useState } from "react";

import { TDatagridData } from "@/components/datagrid-base/types";
import { EmbaixadorService } from "@/modules/embaixador/services";
import { IReferralSummary, IReferredUserActivity } from "../models";
import { useDebounce } from "@/utils/useDebounce";
import { parseMoney } from "@/utils/parseMoney";
import { ContentConditional } from "@/components/content-conditional";
import { useNavigationContext } from "@/contexts";
import { ExpandableDatagrid } from "../components/expandable-datagrid";
import { Modal } from "@/components/modal-base";
import { toast } from "react-toastify";
import { WithdrawalModal } from "../components/withdrawal-modal";
import { SelectPixKeyModal } from "../components/select-pix-key-modal";
export const Ambassador: React.FC = () => {
  const { debounce } = useDebounce();
  const { rowsPerPage, order } = useNavigationContext();

  const [count, setCount] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [busca, setBusca] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [revenue, setRevenue] = useState<number>(0);
  const [balance, setBalance] = useState<number>(0);
  const [affiliates, setAffiliates] = useState<number>(0);
  const [conversionRate, setConversionRate] = useState<number>(0);
  const [bonusRevenue, setBonusRevenue] = useState<number>(0);
  const [data, setData] = useState<IReferredUserActivity[]>([]);
  const [modalLink, setModalLink] = useState<boolean>(false);
  const [modalWithdraw, setModalWithdraw] = useState<boolean>(false);
  const [linkId, setLinkId] = useState("");
  const [modalPixKey, setModalPixKey] = useState<boolean>(false);

  const navigateTable = (newPage: string) => {
    setPage(Number(newPage));
  };
  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      await EmbaixadorService.geTopDashboardData().then(
        (data: IReferralSummary) => {
          setRevenue(data.totalCommissionEarned);
          setBalance(data.balance);
          setAffiliates(data.totalNumberOfReferredUsers);
          setConversionRate(data.conversionRate);
          setBonusRevenue(data.totalMGMBonusAmount);
          setLoading(false);
        }
      );
    };
    fetchData();
  }, []);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      await EmbaixadorService.getDashboardData(
        page,
        busca,
        rowsPerPage,
        order
      ).then((response) => {
        setData(response.data);
        setCount(response.meta!.total);
        setLoading(false);
      });
    };
    fetchData();
  }, [page, busca, rowsPerPage, order]);

  const createRow = (records: IReferredUserActivity[]): TDatagridData[] => {
    return records.map((record) => ({
      name: record.userName,
      email: record.userEmail,
      Eventos: record.events.length,
      "Data de consulta": record.createdAt,
      id: record.userId
    }));
  };
  const renderDetails = (row: any) => {
    const payload = data.filter((item) => item.userId === row.id);
    return <ExpandableDatagrid payload={payload} />;
  };

  const toggleModalLink = () => {
    setModalLink(!modalLink);
  };

  const displayModalLink = async () => {
    await EmbaixadorService.getEmbaixadorData().then((res) => {
      setLinkId(
        "https://app.puxacapivara.com.br/signup?ambassador=" + res.code
      );
      toggleModalLink();
    });
  };
  const copyToClipboard = () => {
    navigator.clipboard.writeText(linkId).then(() => {
      toast.success("Token copiado, compartilhe!");
    });
  };

  const toggleModalWithdraw = () => {
    setModalWithdraw(!modalWithdraw);
  };

  const toggleModalPixKey = () => {
    setModalPixKey((prev) => !prev);
  };

  const fetchPixKey = async () => {
    await EmbaixadorService.getPixKey().then((res) => {
      if (res.pixKeytype) {
        toggleModalWithdraw();
      } else {
        toggleModalPixKey();
      }
    });
  };

  return (
    <Page.Root>
      <Modal.Root maxWidth="600px" open={modalLink} onClose={toggleModalLink}>
        <Modal.Header justifyContent="end">
          <Modal.HeaderText text={"Compartilhe seu código"} />
          <Modal.Icon
            icon="Close"
            cursor="pointer"
            onClick={toggleModalLink}
            iconColor="black"
          />
        </Modal.Header>
        <Modal.Content>
          <a style={{ display: "flex", marginBottom: "2vh" }}>{linkId}</a>
        </Modal.Content>
        <Page.Button
          onClick={copyToClipboard}
          bgColor={theme.colors.palete.green}
          hoverBgcolor={theme.colors.palete.greenHover}
          color="white"
          label="Copiar link"
        />
      </Modal.Root>

      <WithdrawalModal
        modal={modalWithdraw}
        toggleModal={toggleModalWithdraw}
        balance={balance}
      />

      <SelectPixKeyModal modal={modalPixKey} toggleModal={toggleModalPixKey} />

      <Page.Header
        title="Embaixador"
        key="ambassador"
        iconPage={<GroupsIcon />}
      />
      <SaleContainer>
        🔥 Promoção ativa: R$3 por indicado com uso da consulta grátis! Válido
        até 31/12/2025. Saques a partir de R$50.
      </SaleContainer>
      <ContentConditional.IsShow isShow={!loading} key="search">
        <CardsContainer>
          <Card>
            <span className="left">Faturamento:</span>
            <span className="right">{parseMoney(revenue + bonusRevenue)}</span>
          </Card>
          <Card>
            <span className="left">Saldo:</span>
            <span className="right">{parseMoney(balance)}</span>
          </Card>
          <Card>
            <span className="left">Clientes:</span>
            <span className="right">{affiliates}</span>
          </Card>
          <Card>
            <span className="left">Tx Conversão:</span>
            <span className="right">
              {conversionRate.toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}
              %
            </span>
          </Card>
          <Card>
            <span className="left">Receitas Recorrentes</span>
            <span className="right">{parseMoney(revenue)}</span>
          </Card>
          <Card>
            <span className="left">Rec Clientes Ativos:</span>
            <span className="right">{parseMoney(bonusRevenue)}</span>
          </Card>
          <Card onClick={displayModalLink}>
            <div className="icons">
              <ShareOutlinedIcon sx={{ fontSize: theme.fontSize.md2 }} />
              <span>Link</span>
            </div>
          </Card>
          <Card onClick={fetchPixKey}>
            <div className="icons">
              <PixOutlinedIcon sx={{ fontSize: theme.fontSize.md2 }} />
              <span>Saque</span>
            </div>
          </Card>
        </CardsContainer>
      </ContentConditional.IsShow>
      <SearchContainer>
        <Page.Search
          key={"search-history"}
          placeholder={"Procurar cliente"}
          changeTextSearch={(texto) =>
            debounce(() => {
              setBusca(texto);
              setPage(1);
            })
          }
        />
      </SearchContainer>
      <DgContainer>
        <DatagridResponsive.Combo
          headers={[
            { field: "Nome", width: "15vw" },
            { field: "Email", width: "10vw" },
            { field: "Eventos", width: "5vw" },
            { field: "Data da criação", width: "5vw", isSort: true }
          ]}
          renderExpandedRow={renderDetails}
          navigateTable={navigateTable}
          data={createRow(data)}
          loading={loading}
          rowHeader="name"
          count={count}
          page={page}
        />
      </DgContainer>
    </Page.Root>
  );
};
